const styles = {
  container: {
    // height: '100vh',
    // padding: 'clamp(2rem, 3rem, 5rem) 0',
    backgroundColor: '#000',
    color: '#fff',
    textAlign: 'center',
    // backgroundColor: 'red',
    margin: 'clamp(1rem, 20vh, 7rem) 0',
  },

  title: {
    fontSize: 'clamp(2rem, 4vw, 3.12rem)',
    fontFamily: 'Orbitron, sans-serif',
    marginBottom: 'clamp(1rem, 2rem, 3rem)',
  },

  carouselWrapper: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'clamp(26rem, 50vh, 40rem)',
    // marginRight: 'clamp(0.2rem, 6.5vw, 2rem)',
    // padding: 'clamp(6rem, 10vh, 12rem) 0',
    // backgroundColor: 'blue',
  },

  carousel: {
    display: 'flex',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    WebkitOverflowScrolling: 'touch',
    gap: 'clamp(0rem, 8vw, 5rem)',
    padding: 'clamp(6.5rem, 18vh, 10rem) clamp(3.2rem, 4vw, 1.5rem)',
    width: '100%',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    cursor: 'grab',
    userSelect: 'none',
    overflowY: 'hidden', // Bloqueia scroll vertical
    // touchAction: 'pan-x', // Em dispositivos touch, permite apenas scroll horizontal
    // backgroundColor: 'red',
  },

  cardWrapper: {
    scrollSnapAlign: 'center',
    flexShrink: 0,
    padding: 'clamp(0.2rem, 0.3vw, 0.8rem)',
    width: 'calc(clamp(18rem, 30vw, 25rem) + 1px)',
    height: 'clamp(12rem, 20vw, 15.65rem)',
    borderRadius: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },

  bulletsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'clamp(0.3rem, 1vw, 0.6rem)',
    marginTop: 'clamp(1rem, 3vh, 2rem)',
  },

  bullet: {
    width: 'clamp(0.6rem, 1vw, 0.8rem)',
    height: 'clamp(0.6rem, 1vw, 0.8rem)',
    borderRadius: '50%',
    backgroundColor: '#ffffff98',
    transition: 'all 0.3s ease',
  },

  bulletActive: {
    width: 'clamp(1rem, 1.8vw, 1.2rem)',
    height: 'clamp(1rem, 1.8vw, 1.2rem)',
    backgroundColor: '#ffffff',
  },
};

export default styles;
